var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAntimatterIcon = function SvgAntimatterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#31B047"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0253 24.5781C24.624 24.5781 25.9201 23.282 25.9201 21.6832C25.9201 20.0845 24.624 18.7885 23.0253 18.7885C21.4266 18.7885 20.1305 20.0845 20.1305 21.6832C20.1305 23.282 21.4266 24.5781 23.0253 24.5781ZM26.8814 21.6832C26.8814 23.8129 25.155 25.5394 23.0253 25.5394C20.8956 25.5394 19.1692 23.8129 19.1692 21.6832C19.1692 19.5536 20.8956 17.8271 23.0253 17.8271C25.155 17.8271 26.8814 19.5536 26.8814 21.6832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6512 23.6773C20.8434 23.9132 20.8079 24.2601 20.572 24.4523C18.5697 26.0834 16.4844 27.2215 14.6408 27.7188C12.8234 28.2091 11.0877 28.1091 9.9893 27.0107C8.76984 25.7913 8.77748 23.7906 9.47189 21.7321C9.56914 21.4439 9.88167 21.289 10.1699 21.3862C10.4582 21.4835 10.6131 21.796 10.5158 22.0843C9.85674 24.038 10.0134 25.4768 10.7684 26.2317C11.4463 26.9097 12.673 27.1085 14.3539 26.6551C16.0088 26.2087 17.958 25.1606 19.8762 23.5981C20.1121 23.4059 20.4591 23.4414 20.6512 23.6773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8076 12.8915C16.6227 12.6498 16.6688 12.3041 16.9104 12.1192C18.8316 10.6496 20.8054 9.63773 22.5474 9.21768C24.2686 8.80265 25.9012 8.93983 26.9506 9.98922C28.1701 11.2087 28.1624 13.2094 27.468 15.2678C27.3708 15.5561 27.0582 15.711 26.77 15.6137C26.4817 15.5165 26.3268 15.204 26.4241 14.9157C27.0832 12.9619 26.9265 11.5232 26.1715 10.7683C25.5243 10.1211 24.3785 9.90948 22.8056 10.2887C21.2536 10.663 19.4177 11.5884 17.5798 12.9943C17.3382 13.1792 16.9924 13.1331 16.8076 12.8915Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6197 15.0729C18.6197 17.2025 16.8932 18.929 14.7636 18.929C12.6339 18.929 10.9075 17.2025 10.9075 15.0729C10.9075 12.9432 12.6339 11.2168 14.7636 11.2168C16.8932 11.2168 18.6197 12.9432 18.6197 15.0729ZM14.3778 13.1446H15.1491V14.6869H16.6909V15.4581H15.1491V17.0007H14.3778V15.4581H12.8348V14.6869H14.3778V13.1446Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4034 22.0139V21.2427H21.6491V22.0139H24.4034Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAntimatterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/antimatter_icon.408e5350.svg";
export { ForwardRef as ReactComponent };